import React, { useContext, useState, useEffect } from 'react';
import './CartList.css';
import { collectionContext } from '../../App';
import { removeFromDatabaseCart } from '../../utilities/databaseManager';
import CheckoutBlock from './CheckoutBlock';
import ReviewProduct from './ReviewProduct';
import { getWindowDimensions, removeFromCart } from '../../driver';
import { useSelector } from 'react-redux'

const CartList = () => {

    const { value2 } = useContext(collectionContext);
    const { cartData } = useSelector(state => state.cart);
    const [, setRefresh] = value2;
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [])

    
    
    return (
        <div className="container overview product-cart-block">

            <div className="row">
                <div className="col-sm-8 col-lg-9">
                    <ReviewProduct
                        cartData={cartData}
                        windowDimensions={windowDimensions}
                        removeFromCart={removeFromCart}
                        removeFromDatabaseCart={removeFromDatabaseCart}
                        setRefresh={setRefresh}
                    />
                </div>
                <div className="col-sm-4 col-lg-3 check-block">
                    <CheckoutBlock cartData={cartData} />
                </div>
            </div>
        </div>
    );
};

export default CartList;